// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1850": "e56fa031","7630": "83f3e143","7738": "0788e78b","9011": "95fe9399","9940": "ecfff4db",}[chunkId] + ".css"
}